module.exports = __webpack_public_path__ + "static/media/Lexy-360-Teaser-1300.8077d798.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Lexy-360-Teaser-1300.jpg
// module id = 122
// module chunks = 0